import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useSetRecoilState } from 'recoil';
import { CustomerService } from 'api';
import { getCustomersRequestId } from 'api/customers/getCustomers';
import { CUSTOMERS } from 'routes/customers/paths';
import isNorwegian from 'utils/language/isNorwegian';
import mapCustomer from 'utils/mapping/mapCustomer';
export default function useCreateCustomer() {
  const {
    push
  } = useHistory();
  const {
    t,
    i18n
  } = useTranslation();
  const {
    enqueueSnackbar
  } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const setCustomersRequestId = useSetRecoilState(getCustomersRequestId);
  const createCustomer = async (customerObject, customerType) => {
    try {
      setIsLoading(true);
      const mappedCustomer = mapCustomer(customerObject, customerType, isNorwegian(i18n));
      await CustomerService.createNewCustomer({
        body: mappedCustomer
      });
      setCustomersRequestId(prev => prev + 1);
      push(CUSTOMERS);
    } catch (e) {
      enqueueSnackbar(t('error.create_customer'), {
        variant: 'error'
      });
    } finally {
      setIsLoading(false);
    }
  };
  return {
    createCustomer,
    isLoading
  };
}